import HttpRequest from './core/http_request';
class AdminProvider extends HttpRequest {
  // screenManagement
  getScreenCategory (data) {
    return this.request('get', '/private/screen/category', data);
  }

  getScreen (data) {
    return this.request('get', '/private/screen', data);
  }

  getScreenById(data) {
    const id = data._id;
    delete data._id;
    return this.request('get', '/private/screen/id/' + id);
  }

  addScreen (data) {
    delete data._id;
    return this.request('post', '/private/screen', data);
  }

  updateScreen (data) {
    const id = data._id;
    delete data._id;
    return this.request('post', '/private/screen/id/' + id, data);
  }

  deleteScreen (data) {
    const id = data._id;
    delete data._id;
    return this.request('post', '/private/screen/delete/' + id, data);
  }

  updateOrderScreen (data) {
    return this.request('post', '/private/screen/order', data);
  }

  // end screenManagement

  // organizeManagement
  
  getOrganize (data) {
    return this.request('get', '/private/organization', data);
  }

  addOrganize (data) {
    return this.request('post', '/private/organization', data);
  }

  getOrganizeById (data) {
    const id = data._id;
    delete data._id;
    return this.request('get', '/private/organization/id/' + id);
  }

  getCode () {
    return this.request('get', '/private/organization/generateCode')
  }

  updateOrganize (data) {
    const id = data._id;
    delete data._id;
    return this.request('post', '/private/organization/id/' + id, data)
  }

  deleteOrganize (data) {
    const id = data._id;
    delete data._id;
    return this.request('post', '/private/organization/delete/' + id)
  }

  updateAllscreenPermission (data) {
    const id = data.idParent;
    delete data.idParent;
    return this.request('post', '/private/organization/screenPermission/upsert/' + id, data);
  }

  // end organizeManagement

  // userManagement

  getMemberByOrganization (data) {
    const id = data._id;
    delete data._id;
    return this.request('get', '/private/organization/members/' + id, data);
  }

  getMemberById (data) {
    const id = data._id;
    delete data._id;
    return this.request('get', '/private/member/id/' + id);
  }

  getMemberByEmail (data) {
    const email = data.email;
    const organizationId = data.organizationId;
    delete data.email;
    delete data.organizationId
    return this.request('get', '/private/member/email/' + email + '/' + organizationId);
  }

  grantPermission (data) {
    const organizationId = data._id;
    delete data._id;
    return this.request('post', '/private/organization/grantPermission/' + organizationId, data);
  }

  grantPermissionAll (data) {
    const organizationId = data._id;
    delete data._id;
    return this.request('post', '/private/organization/grantPermissionAll/' + organizationId, data);
  }

  addAdmin (data) {
    const id = data._id;
    delete data._id;
    return this.request('post', '/private/member/role/toggle/' + id, data);
  }

  updateMemberPermission (data) {
    const id = data._id;
    delete data._id;
    return this.request('post', '/private/member/screenPermission/update/' + id, data);
  }

  deleteMember (data) {
    const id = data._id;
    delete data._id;
    return this.request('post', '/private/member/delete/' + id);
  }

  addWaterSupplyAdmin (data) {
    return this.request('post', '/private/member/watersupply/admin', data);
  }
  // end userManagement
  // waterSupplyManagement 
  createMasterWaterSupply (data) {
    return this.request('post', '/private/masterWaterSupply', data);
  }
  
  getMasterWaterSupplyList (data) {
    return this.request('get', '/private/masterWaterSupply', data);
  }

  getMasterWaterSupplyById (data) {
    const id = data._id;
    delete data._id;
    return this.request('get', '/private/masterWaterSupply/id/' + id);
  }

  updateMasterWaterSupply (data) {
    const id = data._id;
    delete data._id;
    return this.request('post', '/private/masterWaterSupply/id/' + id, data);
  }

  deleteMasterWaterSupply (data) {
    const id = data._id;
    delete data._id;
    return this.request('post', '/private/masterWaterSupply/delete/' + id);
  }
  // end waterSupplyManagement
}

export default AdminProvider;
